import { render, staticRenderFns } from "./NoActiveStore.vue?vue&type=template&id=476bcf88&"
import script from "./NoActiveStore.vue?vue&type=script&lang=js&"
export * from "./NoActiveStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports